import {
  Body,
  BottomSheet,
  Caption,
  Col,
  Flex,
  LazyImage,
  Loading,
} from '@teko/ds-mobile';
import { ProductGrid } from '@teko/teko-ecommerce';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { useSearch, useTenantConfig } from 'hooks';
import { t } from 'i18n';

interface RelatedProductsBottomSheetProps {
  sku: string;
  imageUrl?: string;
  name?: string;
  categoryId?: number;
  closeBottomSheet?: () => void;
}

export const RelatedProductsBottomSheet: React.FC<
  RelatedProductsBottomSheetProps
> = (props: RelatedProductsBottomSheetProps) => {
  const { sku, categoryId, imageUrl, name, closeBottomSheet } = props;
  const { passSkuToReturnSimilarProducts, contactLink } = useTenantConfig();
  const searchRelatedProductsParams =
    !!sku && passSkuToReturnSimilarProducts
      ? {
          page: 1,
          pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
          filter: {
            skuToReturnSimilarProducts: sku,
          },
        }
      : !!categoryId && !!sku
      ? {
          page: 1,
          pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
          filter: {
            excludedSkus: [sku],
            categoryIds: [categoryId],
          },
        }
      : {};

  const { result: searchRelatedProductsResult, isLoading } = useSearch(
    searchRelatedProductsParams,
  );
  return (
    <BottomSheet
      zIndex={1051}
      show={!!sku}
      title={t('Sản phẩm tương tự')}
      closeBottomSheet={closeBottomSheet}
      contentHeight="80vh"
      closeIconPosition="right"
    >
      <Col
        backgroundColor="background"
        borderTop="2px solid background"
        height="100%"
        width="100vw"
      >
        <Loading isLoading={isLoading} />
        <Flex
          backgroundColor="white"
          align="center"
          justify="start"
          margin={['s8', 's8', 's4', 's8']}
          padding="s4"
          borderRadius="m"
          gap="s4"
        >
          {imageUrl && (
            <LazyImage width="32px" height="32px" src={imageUrl} contain />
          )}
          <div style={{ flex: 1 }}>
            <Caption level={1} line={2}>
              {name}
            </Caption>
          </div>
        </Flex>
        <Body level={1} paddingLeft="s8" marginBottom="s4">
          {t('Tìm thấy')}{' '}
          <strong>
            {searchRelatedProductsResult.pagination.totalItems <
            LIMIT_ITEM_PER_PAGE_PRODUCT_LIST
              ? searchRelatedProductsResult.pagination.totalItems
              : LIMIT_ITEM_PER_PAGE_PRODUCT_LIST}{' '}
          </strong>
          {t('sản phẩm tương tự')}
        </Body>
        <ProductGrid
          type="grid"
          products={searchRelatedProductsResult.products}
          regionName="relatedProductsBottomSheet"
          contactLink={contactLink}
          productsPerRow={2}
          itemsPerPage={LIMIT_ITEM_PER_PAGE_PRODUCT_LIST}
        />
      </Col>
    </BottomSheet>
  );
};
